import dayjs from 'dayjs';
import { DateFormats } from './constants';

export const formatDate = (date = '', format = '') => {
  return dayjs(date).format(format);
};

export const isBeforeDate = (sourceDate = '', targetDate = '') => {
  return dayjs(sourceDate).isBefore(targetDate);
};

export const diffDate = (sourceDate = '', targetDate = '') => {
  const firstDate = dayjs(sourceDate);
  const secondDate = dayjs(targetDate);
  return firstDate.diff(secondDate);
};

export const addDaysToDate = (currentDate, days = 0) => {
  return new Date(currentDate).setDate(new Date(currentDate).getDate() + days);
};

export const currentDate = () => {
  return new Date().toLocaleDateString('en-US');
};

export const handleDate = (date, format = DateFormats.mm_dd_yy) =>
  !!date ? formatDate(date, format) : '––';

export const getDayJSObject = (date) => (date ? dayjs(date) : null);

export const getISODate = (date) => dayjs(date).toISOString();

// True when `from` is not after `to` (or either bound is unset).
export const isDateRangeValid = (from, to) => {
  if (!from || !to) return true;
  return !dayjs(from).isAfter(dayjs(to), 'day');
};

// True when `date` is not further back than `maxDaysBack` days from today, and not in the future.
export const isWithinMaxLookback = (date, maxDaysBack) => {
  const target = dayjs(date);
  return (
    !target.isBefore(dayjs().subtract(maxDaysBack, 'day'), 'day') &&
    !target.isAfter(dayjs(), 'day')
  );
};

// Inclusive created_at range predicate for a lead/vehicle `where` clause.
export const generateCreatedAtRangeQuery = ({ from, to } = {}) => ({
  created_at: {
    ...(from && { _gte: dayjs(from).startOf('day').toISOString() }),
    ...(to && { _lte: dayjs(to).endOf('day').toISOString() }),
  },
});

export const getExpiredStatus = ({
  date,
  isAmazonOrCapitalOneLead,
  hasDealerPrice,
  acceptedDate,
}) => {
  const currentDate = dayjs();
  const daysDifference = currentDate.diff(date, 'day');

  let isExpired = false;

  if (
    !acceptedDate &&
    (daysDifference >= 7 ||
      (isAmazonOrCapitalOneLead && hasDealerPrice && daysDifference >= 3))
  ) {
    isExpired = true;
  }
  return isExpired;
};
